import React, { FC, useState, useEffect } from 'react';

import { Product, getProductDetails } from './services/api';

import { GlobalStyle, Loader } from './styles';
import PaymentFormContainer from './components/container/paymentFormContainer';
import AppFooter from './components/presentation/appFooter';

const [productId] = (window.location.search.split('product_id=')[1] ?? '').split('&');

const App: FC = () => {
  const [product, setProduct] = useState<Product>();
  useEffect(() => {
    getProductDetails(productId).then(setProduct).catch(console.error);
  }, []);
  return (
    <>
      <GlobalStyle />
      {!product && (
        <div
          style={{
            width: '100vw',
            height: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Loader />
        </div>
      )}
      {product && (
        <>
          <PaymentFormContainer
            productId={productId}
            amount={product.price.toString(10)}
            allowBankSlip={product.allowBankSlip}
            productDescription={product.description}
            productTitle={product.name}
            productImage={product.imageUrl}
            creditCardThankYouPage={product.thankYouPage}
            boletoThankYouPage={product.boletoPage}
            defaultInstallments={product.defaultInstallments}
          />
          <AppFooter />
        </>
      )}
    </>
  );
};

export default App;
